import "./JuniorAcademy.module.css";
import Header from "@/reusable_sections/Header";
import OurMaterialStandards from "./sections/OurMaterialStandards";
import TheArchitectsOfSpeech from "./sections/TheArchitectsOfSpeech";
import ForfaitsSurMesure from "./sections/ForfaitsSurMesure";
import Footer from "@/reusable_sections/Footer";
export default function JuniorAcademyPage() {
  return <div>
      <Header />
      <OurMaterialStandards />
      <TheArchitectsOfSpeech />
      <ForfaitsSurMesure />
      <Footer />
    </div>;
}